import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  bookmark: [],
  isLoading: false,
  error: null,
  bookmarkDetails: {},
  isLoadingBookmarkDetails: false,
  isErrorBookmarkDetails: false,
  postBookmark: {},
  isLoadingPostBookmark: false,
  isErrorPostBookmark: false,
  deleteBookmark: {},
  isLoadingDeleteBookmark: false,
  errorDeleteBookmark: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bookmark/index.js